<template>
  <div class="StudentAgreements">
    <btn class="add" @click.native="switchV('form'), getData(student)" v-bind:class="{ 'slideActive': form }">契約追加</btn>
    <template v-if="form">

      <p class="m-label">
        新規追加
        <span class="errors">
          <span v-if="!valid"> {{errors}} が入力されていません</span>
          <span v-if="valid"></span>
        </span>
      </p>

      <form class="h-adr" @submit.prevent="postAgreement" @keypress.stop.prevent.13>
        <div class="form-wrapper">
          <agreement-form :agreement="agreement" :watch="watchAgreement"></agreement-form>
        </div>

        <btn type="submit" class="u-btn m-btn--default"><i class="fa fa-user-plus"></i>契約内容を新規追加</btn>
      </form>

    </template>
    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c><input v-model="searchQuery.id" type="text" placeholder="検索"></td-c>
          <td-c><input v-model="searchQuery.student_id" type="text" placeholder=""></td-c>
          <!-- <td&#45;c><input v&#45;model="searchQuery.user_id" type="text" placeholder=""></td&#45;c> -->
          <td-c><input v-model="searchQuery.contract_type" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.contract_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.change_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.cancel_type" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.cancel_date" type="text" placeholder=""></td-c>
          <!-- <td&#45;c><input v&#45;model="searchQuery.amount" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.diucout" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.split_commission" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.sales_commission" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.sales_commission_head" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.sales_commission_branch" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.pure_amount" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.pure_amount_head" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.pure_amount_branch" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.old_amount" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.agency_commission" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.agency_commission_head" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.agency_commission_branch" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.purchase_amount" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.purchase_amount_head" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.purchase_amount_branch" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.only_total_amount" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.only_total_amount_head" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.only_total_amount_branch" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.down_payment" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.deposit_amount" type="text" placeholder=""></td&#45;c> -->
          <td-c><input v-model="searchQuery.person" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.product_name" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.payment_type" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.text_type" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.payments_number" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.deposit_amount_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.text_payment_period_start" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.text_payment_period_end" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.service_period_start" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.service_period_end" type="text" placeholder=""></td-c>
          <!-- <td&#45;c><input v&#45;model="searchQuery.administrative_expense" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.first_month_deposit" type="text" placeholder=""></td&#45;c> -->
          <td-c><input v-model="searchQuery.first_month_deposit_method" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.first_month_deposit_check" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.admission_fee" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.admission_fee_method" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.admission_fee_check" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.deposit" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.deposit_method" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.deposit_check" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.deposit_refund_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.approval_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.approval_number" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.delivery_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.contract_collection_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.factor_collection_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.grade" type="text" placeholder=""></td-c>
          <!-- <td&#45;c><input v&#45;model="searchQuery.point_s" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.point_c" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.point_k" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.point_s_bulk" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.point_c_bulk" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="searchQuery.point_k_bulk" type="text" placeholder=""></td&#45;c> -->
          <td-c><input v-model="searchQuery.point_total" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.note" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.created_at" type="text" placeholder=""></td-c>
          <td-c><input v-model="searchQuery.updated_at" type="text" placeholder=""></td-c>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c><input v-model="notSearchQuery.id" type="text" placeholder="除外"></td-c>
          <td-c><input v-model="notSearchQuery.student_id" type="text" placeholder=""></td-c>
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.user_id" type="text" placeholder=""></td&#45;c> -->
          <td-c><input v-model="notSearchQuery.contract_type" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.contract_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.change_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.cancel_type" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.cancel_date" type="text" placeholder=""></td-c>
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.amount" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.diucout" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.split_commission" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.sales_commission" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.sales_commission_head" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.sales_commission_branch" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.pure_amount" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.pure_amount_head" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.pure_amount_branch" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.old_amount" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.agency_commission" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.agency_commission_head" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.agency_commission_branch" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.purchase_amount" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.purchase_amount_head" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.purchase_amount_branch" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.only_total_amount" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.only_total_amount_head" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.only_total_amount_branch" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.down_payment" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.deposit_amount" type="text" placeholder=""></td&#45;c> -->
          <td-c><input v-model="notSearchQuery.person" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.product_name" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.payment_type" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.text_type" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.payments_number" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.deposit_amount_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.text_payment_period_start" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.text_payment_period_end" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.service_period_start" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.service_period_end" type="text" placeholder=""></td-c>
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.administrative_expense" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.first_month_deposit" type="text" placeholder=""></td&#45;c> -->
          <td-c><input v-model="notSearchQuery.first_month_deposit_method" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.first_month_deposit_check" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.admission_fee" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.admission_fee_method" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.admission_fee_check" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.deposit" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.deposit_method" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.deposit_check" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.deposit_refund_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.approval_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.approval_number" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.delivery_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.contract_collection_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.factor_collection_date" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.grade" type="text" placeholder=""></td-c>
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.point_s" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.point_c" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.point_k" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.point_s_bulk" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.point_c_bulk" type="text" placeholder=""></td&#45;c> -->
          <!-- <td&#45;c><input v&#45;model="notSearchQuery.point_k_bulk" type="text" placeholder=""></td&#45;c> -->
          <td-c><input v-model="notSearchQuery.point_total" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.note" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.created_at" type="text" placeholder=""></td-c>
          <td-c><input v-model="notSearchQuery.updated_at" type="text" placeholder=""></td-c>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c @click.native="sort('id')">ID</th-c>
          <th-c @click.native="sort('student_id')">Student ID</th-c>
          <th-c @click.native="sort('contract_type')">契約種類</th-c>
          <th-c @click.native="sort('contract_date')">契約日付</th-c>
          <th-c @click.native="sort('change_date')">内容変更日付</th-c>
          <th-c @click.native="sort('cancel_type')">解約種類</th-c>
          <th-c @click.native="sort('cancel_date')">解約日付</th-c>
          <!-- <th&#45;c @click.native="sort('amount')">定価</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('discount')">値引き</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('split_commission')">split_commission</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('sales_commission')">sales_commission</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('sales_commission_head')">sales_commission_head</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('sales_commission_branch')">sales_commission_branch</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('pure_amount')">販売価格</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('pure_amount_head')">販売価格(本社)</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('pure_amount_branch')">販売価格(支店)</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('old_amount')">旧販売価格</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('agency_commission')">代行手数料</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('agency_commission_head')">代行手数料(本社)</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('agency_commission_branch')">代行手数料(支店)</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('purchase_amount')">仕入れ価格</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('purchase_amount_head')">仕入れ価格(本社)</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('purchase_amount_branch')">仕入れ価格(支店)</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('only_total_amount')">のみ合計金額</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('only_total_amount_head')">のみ合計金額(本社k)</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('only_total_amount_branch')">のみ合計金額(支店)</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('down_payment')">頭金</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('deposit_amount')">入金額</th&#45;c> -->
          <th-c @click.native="sort('person')">担当者</th-c>
          <th-c @click.native="sort('product_name')">商品名</th-c>
          <th-c @click.native="sort('payment_type')">支払方法種別</th-c>
          <th-c @click.native="sort('text_type')">テキスト種類</th-c>
          <th-c @click.native="sort('payments_number')">支払回数</th-c>
          <th-c @click.native="sort('deposit_amount_date')">テキスト代入金日</th-c>
          <th-c @click.native="sort('text_payment_period_start')">支払期間/開始(テキスト)</th-c>
          <th-c @click.native="sort('text_payment_period_end')">支払期間/終了(テキスト)</th-c>
          <th-c @click.native="sort('service_period_start')">役務期間/開始</th-c>
          <th-c @click.native="sort('service_period_end')">役務期間/終了</th-c>
          <!-- <th&#45;c @click.native="sort('administrative_expense')">管理費</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('first_month_deposit')">初月管理費</th&#45;c> -->
          <th-c @click.native="sort('first_month_deposit_method')">初月管理費支払方法</th-c>
          <th-c @click.native="sort('first_month_deposit_check')">初月管理費チェック</th-c>
          <th-c @click.native="sort('admission_fee')">入会金</th-c>
          <th-c @click.native="sort('admission_fee_method')">入会金支払方法</th-c>
          <th-c @click.native="sort('admission_fee_check')">入会金チェック</th-c>
          <th-c @click.native="sort('deposit')">保証金</th-c>
          <th-c @click.native="sort('deposit_method')">保証金支払方法</th-c>
          <th-c @click.native="sort('deposit_check')">保証金チェック</th-c>
          <th-c @click.native="sort('deposit_refund_date')">保証金返金日</th-c>
          <th-c @click.native="sort('approval_date')">承認日</th-c>
          <th-c @click.native="sort('approval_number')">承認No.</th-c>
          <th-c @click.native="sort('delivery_date')">納品日</th-c>
          <th-c @click.native="sort('contract_collection_date')">契約書回収日</th-c>
          <th-c @click.native="sort('factor_collection_date')">ファクター回収日</th-c>
          <th-c @click.native="sort('grade')">学年</th-c>
          <!-- <th&#45;c @click.native="sort('point_s')">P小学</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('point_c')">P中学</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('point_k')">P高校</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('point_s_bulk')">一括P小学</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('point_c_bulk')">一括P中学</th&#45;c> -->
          <!-- <th&#45;c @click.native="sort('point_k_bulk')">一括P高校</th&#45;c> -->
          <th-c @click.native="sort('point_total')">合計P</th-c>
          <th-c @click.native="sort('note')">備考</th-c>
          <th-c @click.native="sort('created_at')">作成日</th-c>
          <th-c @click.native="sort('updated_at')">更新日</th-c>
        </tr-c>

        <tr-c @click.native='linkAgreement(list)' slot="tr-td" v-for="(list, index) in notFilteredAgreements" :key="index.id" class="tr_hover">
          <td-c>{{list.id}}</td-c>
          <td-c>{{list.student_id}}</td-c>
          <td-c>{{list.contract_type}}</td-c>
          <td-c>{{list.contract_date}}</td-c>
          <td-c>{{list.change_date}}</td-c>
          <td-c>{{list.cancel_type}}</td-c>
          <td-c>{{list.cancel_date}}</td-c>
          <!-- <td&#45;c>{{list.amount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.discount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.split_commission}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.sales_commission}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.sales_commission_head}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.sales_commission_branch}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.pure_amount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.pure_amount_head}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.pure_amount_branch}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.old_amount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.agency_commission}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.agency_commission_head}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.agency_commission_branch}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.purchase_amount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.purchase_amount_head}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.purchase_amount_branch}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.only_total_amount}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.only_total_amount_head}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.only_total_amount_branch}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.down_payment}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.deposit_amount}}</td&#45;c> -->
          <td-c>{{list.person}}</td-c>
          <td-c>{{list.product_name}}</td-c>
          <td-c>{{list.payment_type}}</td-c>
          <td-c>{{list.text_type}}</td-c>
          <td-c>{{list.payments_number}}</td-c>
          <td-c>{{list.deposit_amount_date}}</td-c>
          <td-c>{{list.text_payment_period_start}}</td-c>
          <td-c>{{list.text_payment_period_end}}</td-c>
          <td-c>{{list.service_period_start}}</td-c>
          <td-c>{{list.service_period_end}}</td-c>
          <!-- <td&#45;c>{{list.administrative_expense}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.first_month_deposit}}</td&#45;c> -->
          <td-c>{{list.first_month_deposit_method}}</td-c>
          <td-c>{{list.first_month_deposit_check}}</td-c>
          <td-c>{{list.admission_fee}}</td-c>
          <td-c>{{list.admission_fee_method}}</td-c>
          <td-c>{{list.admission_fee_check}}</td-c>
          <td-c>{{list.deposit}}</td-c>
          <td-c>{{list.deposit_check}}</td-c>
          <td-c>{{list.deposit_refund_date}}</td-c>
          <td-c>{{list.deposit_method}}</td-c>
          <td-c>{{list.approval_date}}</td-c>
          <td-c>{{list.approval_number}}</td-c>
          <td-c>{{list.delivery_date}}</td-c>
          <td-c>{{list.contract_collection_date}}</td-c>
          <td-c>{{list.factor_collection_date}}</td-c>
          <td-c>{{list.grade}}</td-c>
          <!-- <td&#45;c>{{list.point_s}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.point_c}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.point_k}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.point_s_bulk}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.point_c_bulk}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.point_k_bulk}}</td&#45;c> -->
          <td-c>{{list.point_total}}</td-c>
          <td-c>{{list.note}}</td-c>
          <td-c>{{list.created_at}}</td-c>
          <td-c>{{list.updated_at}}</td-c>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/agreements/search?limit=' + config.LIMIT

// var TIMER = null
var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  max: config.LIMIT,
  url: url,
  pageName: 'agreement',
  pageNames: 'agreements'
}

let _ = window._
export default {
  props: {
    student: Object
  },

  computed: {
    advisors () {
      return this.$store.getters.advisors
    },

    contract_type () {
      return this.$store.getters['agreements/contract_type']
    },

    payment_type () {
      return this.$store.getters['agreements/payment_type']
    },

    text_type () {
      return this.$store.getters['agreements/text_type']
    },

    payments_number () {
      return this.$store.getters['agreements/payments_number']
    },

    method () {
      return this.$store.getters['agreements/method']
    },

    // filter By
    FilteredAgreements () {
      var self = this // function の中でthisが使えないのでselfに置き換え
      var key = Object.keys(this.searchQuery) // ["id", "student_id",・・・]
      // console.log(key)
      let isSearch = key.every((e) => {
        if (!self.searchQuery[e]) {
          return true // default (全てfalseの場合)
        } else {
          return false // search 何か入力されてたらsearch
        }
      })
      // console.log(isSearch)
      if (isSearch) {
        return self.student.agreements // 全部返す
      }
      // isSearch じゃなければfilterする
      return self.student.agreements.filter((el) => {
        let re = [] // 正規表現の配列
        for (var i = 0; i < key.length; i++) {
          re.push(new RegExp(self.searchQuery[key[i]]))
        }
        // console.log(re)

        let els = [] // 正規表現と入力された値をtest関数で比べて返ってきたtrue,falseの配列
        for (var t = 0; t < key.length; t++) {
          let column = key[t]
          let input = el[[column]]
          els.push(re[t].test(input))
        }
        // console.log(els)

        let flg = els.every((el) => {
          if (el) {
            return true
          } else {
            return false
          }
        })
        // console.log(flg)
        return flg
      })
    },

    notFilteredAgreements () {
      var self = this // function の中でthisが使えないのでselfに置き換え
      var key = Object.keys(this.notSearchQuery) // ["id", "student_id",・・・]
      // console.log(key)
      let isSearch = key.every((e) => {
        if (!self.notSearchQuery[e]) {
          return true // default (全てfalseの場合)
        } else {
          return false // search 何か入力されてたらsearch
        }
      })
      // console.log(isSearch)
      if (isSearch) {
        return self.FilteredAgreements // 全部返す FilteredAgreementsを返す
      }
      // isSearch じゃなければfilterする
      return self.FilteredAgreements.filter((el) => { // FilteredAgreementsにfilterをかける
        let re = [] // 正規表現の配列
        for (var i = 0; i < key.length; i++) {
          re.push(new RegExp(self.notSearchQuery[key[i]]))
        }
        // console.log(re)

        let els = [] // 正規表現と入力された値をtest関数で比べて返ってきたtrue,falseの配列
        for (var t = 0; t < key.length; t++) {
          let column = key[t]
          let input = el[[column]]
          els.push(re[t].test(input))
        }
        // console.log(els)

        let flg = els.every((el) => {
          if (el) {
            return true
          } else {
            return false
          }
        })
        // console.log(flg)
        return !flg // 反転
      })
    },

    // limit By
    // limitedAgreements () {
    //   return this.student.agreements.slice(0, 5)
    // },

    // order By
    orderedAgreements () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.student.agreements, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.student.agreements, this.desc).reverse()
      }
    },

    // validation
    telErrors () {
      return this.agreement.tel ? [] : ['携帯TEL']
    },

    contract_typeErrors () {
      return this.agreement.contract_type ? [] : ['契約種類']
    },

    payment_typeErrors () {
      return this.agreement.payment_type ? [] : ['支払方法種別']
    },

    text_typeErrors () {
      return this.agreement.text_type ? [] : ['テキスト種類']
    },

    payments_numberErrors () {
      return this.agreement.payments_number ? [] : ['支払回数']
    },

    admission_feeErrors () {
      return this.agreement.admission_fee ? [] : ['入会金']
    },

    depositErrors () {
      return this.agreement.deposit ? [] : ['保証金']
    },

    errors () {
      let errors = [].concat(
        this.telErrors,
        this.contract_typeErrors,
        this.payment_typeErrors,
        this.text_typeErrors,
        this.payments_numberErrors,
        this.admission_feeErrors,
        this.depositErrors
      )
      let errorsJoin = errors.join('・')
      return errorsJoin
    },
    valid () {
      return !this.errors
    }
  },

  data () {
    return {
      form: false,
      asc: '',
      desc: '',
      sortState: '',
      searchType: 'id',

      agreement: {
        // user_id: '',
        student_id: '',
        contract_type: '',
        contract_date: '',
        change_date: '',
        cancel_type: '',
        cancel_date: '',
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        tel: '',
        tel2: '',
        address: '',
        address2: '',
        // birthday: '',
        // hourly_pay: '',
        // amount: '',
        // discount: '',
        // split_commission: '',
        // sales_commission: '',
        // sales_commission_head: '',
        // sales_commission_branch: '',
        // pure_amount: '',
        // pure_amount_head: '',
        // pure_amount_branch: '',
        // old_amount: '',
        // agency_commission: '',
        // agency_commission_head: '',
        // agency_commission_branch: '',
        // purchase_amount: '',
        // purchase_amount_head: '',
        // purchase_amount_branch: '',
        // only_total_amount: '',
        // only_total_amount_head: '',
        // only_total_amount_branch: '',
        // down_payment: '',
        // deposit_amount: '',
        person: '',
        product_name: '',
        payment_type: '',
        payments_number: '',
        deposit_amount_date: '',
        text_type: '',
        // text_grade_number: '',
        text_payment_period_start: '',
        text_payment_period_end: '',
        service_period_start: '',
        service_period_end: '',
        // administrative_expense: '',
        // first_month_deposit: '',
        first_month_deposit_method: '',
        first_month_deposit_check: '',
        admission_fee: '',
        admission_fee_method: '',
        admission_fee_check: '',
        deposit: '',
        deposit_check: '',
        deposit_refund_date: '',
        deposit_method: '',
        approval_date: '',
        approval_number: '',
        delivery_date: '',
        contract_collection_date: '',
        factor_collection_date: '',
        grade: '',
        // point_s: '',
        // point_c: '',
        // point_k: '',
        // point_s_bulk: '',
        // point_c_bulk: '',
        // point_k_bulk: '',
        point_total: '',
        note: ''
      },

      watchAgreement: {
        contract_type: '',
        cancel_type: '',
        payment_type: '',
        text_type: '',
        payments_number: '',
        first_month_deposit_method: '',
        admission_fee_method: '',
        deposit: '',
        deposit_method: ''
      },

      searchQuery: {
        // 検索
        // user_id: '',
        student_id: '',
        contract_type: '',
        contract_date: '',
        change_date: '',
        cancel_type: '',
        cancel_date: '',
        // f_name: '',
        // l_name: '',
        // f_name_kana: '',
        // l_name_kana: '',
        // tel: '',
        // tel2: '',
        // address: '',
        // address2: '',
        // birthday: '',
        // hourly_pay: '',
        // amount: '',
        // discount: '',
        // split_commission: '',
        // sales_commission: '',
        // sales_commission_head: '',
        // sales_commission_branch: '',
        // pure_amount: '',
        // pure_amount_head: '',
        // pure_amount_branch: '',
        // old_amount: '',
        // agency_commission: '',
        // agency_commission_head: '',
        // agency_commission_branch: '',
        // purchase_amount: '',
        // purchase_amount_head: '',
        // purchase_amount_branch: '',
        // only_total_amount: '',
        // only_total_amount_head: '',
        // only_total_amount_branch: '',
        // down_payment: '',
        // deposit_amount: '',
        person: '',
        product_name: '',
        payment_type: '',
        payments_number: '',
        deposit_amount_date: '',
        text_type: '',
        // text_grade_number: '',
        text_payment_period_start: '',
        text_payment_period_end: '',
        service_period_start: '',
        service_period_end: '',
        // administrative_expense: '',
        // first_month_deposit: '',
        first_month_deposit_method: '',
        first_month_deposit_check: '',
        admission_fee: '',
        admission_fee_method: '',
        admission_fee_check: '',
        deposit: '',
        deposit_check: '',
        deposit_refund_date: '',
        deposit_method: '',
        approval_date: '',
        approval_number: '',
        delivery_date: '',
        contract_collection_date: '',
        factor_collection_date: '',
        grade: '',
        // point_s: '',
        // point_c: '',
        // point_k: '',
        // point_s_bulk: '',
        // point_c_bulk: '',
        // point_k_bulk: '',
        point_total: '',
        note: '',
        created_at: '',
        updated_at: ''
      },

      notSearchQuery: {
        // 除外
        id: '',
        student_id: '',
        // user_id: '',
        contract_type: '',
        contract_date: '',
        change_date: '',
        cancel_date: '',
        // amount: '',
        // discount: '',
        // split_commission: '',
        // sales_commission: '',
        // sales_commission_head: '',
        // sales_commission_branch: '',
        // pure_amount: '',
        // pure_amount_head: '',
        // pure_amount_branch: '',
        // old_amount: '',
        // agency_commission: '',
        // agency_commission_head: '',
        // agency_commission_branch: '',
        // purchase_amount: '',
        // purchase_amount_head: '',
        // purchase_amount_branch: '',
        // only_total_amount: '',
        // only_total_amount_head: '',
        // only_total_amount_branch: '',
        // down_payment: '',
        // deposit_amount: '',
        person: '',
        product_name: '',
        payment_type: '',
        text_type: '',
        payments_number: '',
        deposit_amount_date: '',
        text_payment_period_start: '',
        text_payment_period_end: '',
        service_period_start: '',
        service_period_end: '',
        // administrative_expense: '',
        // first_month_deposit: '',
        first_month_deposit_method: '',
        first_month_deposit_check: '',
        admission_fee: '',
        admission_fee_method: '',
        admission_fee_check: '',
        deposit: '',
        deposit_method: '',
        deposit_check: '',
        deposit_refund_date: '',
        approval_date: '',
        approval_number: '',
        delivery_date: '',
        contract_collection_date: '',
        factor_collection_date: '',
        grade: '',
        // point_s: '',
        // point_c: '',
        // point_k: '',
        // point_s_bulk: '',
        // point_c_bulk: '',
        // point_k_bulk: '',
        point_total: '',
        note: '',
        created_at: '',
        updated_at: ''
      }
    }
  },

  watch: {
    'watchAgreement.contract_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.contract_type = now.value
      } else {
        this.agreement.contract_type = ''
      }
    },

    'watchAgreement.cancel_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.cancel_type = now.value
      } else {
        this.agreement.cancel_type = ''
      }
    },

    'watchAgreement.payment_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.payment_type = now.value
      } else {
        this.agreement.payment_type = ''
      }
    },

    'watchAgreement.text_type': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.text_type = now.value
      } else {
        this.agreement.text_type = ''
      }
    },

    'watchAgreement.payments_number': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.payments_number = now.value
      } else {
        this.agreement.payments_number = ''
      }
    },

    'watchAgreement.first_month_deposit_method': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.first_month_deposit_method = now.value
      } else {
        this.agreement.first_month_deposit_method = ''
      }
    },

    'watchAgreement.admission_fee_method': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.admission_fee_method = now.value
      } else {
        this.agreement.admission_fee_method = ''
      }
    },

    'watchAgreement.deposit': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.deposit = now.value
      } else {
        this.agreement.deposit = ''
      }
    },

    'watchAgreement.deposit_method': function (now, old) {
      // console.log(now)
      if (now) {
        this.agreement.deposit_method = now.value
      } else {
        this.agreement.deposit_method = ''
      }
    }
  },

  methods: {
    switchV (col) {
      this[col] = !this[col]
    },

    linkAgreement (agreement) {
      this.$router.push({name: 'agreementindex', params: { id: agreement.id }})
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    // searchTable (e) {
    //   this.$store.dispatch('SEARCH', {
    //     this: this,
    //     e: e,
    //     obj: obj
    //   })
    // },

    getData (student) {
      this.agreement.student_id = student.id
      // console.log(student)
      this.agreement.f_name = student.family.f_name
      this.agreement.l_name = student.family.l_name
      this.agreement.f_name_kana = student.family.f_name_kana
      this.agreement.l_name_kana = student.family.l_name_kana
      this.agreement.tel = student.family.tel1
      this.agreement.tel2 = student.family.tel2
      this.agreement.address = student.family.address1
      this.agreement.address2 = student.family.address2
      this.agreement.service_period_start = student.service_period_start
      this.agreement.service_period_end = student.service_period_end
    },

    postAgreement () {
      this.$store.dispatch('postAgreement', {
        this: this,
        agreement: this.agreement,
        watch: this.watchAgreement,
        reset: this.reset
      })
    },

    save () {
      // alert('save')
      let arr = []
      let obj = {

        contract_type: this.watchAgreement.contract_type,
        contract_date: this.agreement.contract_date,
        change_date: this.agreement.change_date,
        cancel_type: this.watchAgreement.cancel_type,
        cancel_date: this.agreement.cancel_date,
        f_name: this.agreement.f_name,
        l_name: this.agreement.l_name,
        f_name_kana: this.agreement.f_name_kana,
        l_name_kana: this.agreement.l_name_kana,
        tel: this.agreement.tel,
        tel2: this.agreement.tel2,
        address: this.agreement.address,
        address2: this.agreement.address2,
        birthday: this.agreement.birthday,
        hourly_pay: this.agreement.hourly_pay,
        amount: this.agreement.amount,
        discount: this.agreement.discount,
        split_commission: this.agreement.split_commission,
        sales_commission: this.agreement.sales_commission,
        sales_commission_head: this.agreement.sales_commission_head,
        sales_commission_branch: this.agreement.sales_commission_branch,
        pure_amount: this.agreement.pure_amount,
        pure_amount_head: this.agreement.pure_amount_head,
        pure_amount_branch: this.agreement.pure_amount_branch,
        old_amount: this.agreement.old_amount,
        agency_commission: this.agreement.agency_commission,
        agency_commission_head: this.agreement.agency_commission_head,
        agency_commission_branch: this.agreement.agency_commission_branch,
        purchase_amount: this.agreement.purchase_amount,
        purchase_amount_head: this.agreement.purchase_amount_head,
        purchase_amount_branch: this.agreement.purchase_amount_branch,
        only_total_amount: this.agreement.only_total_amount,
        only_total_amount_head: this.agreement.only_total_amount_head,
        only_total_amount_branch: this.agreement.only_total_amount_branch,
        down_payment: this.agreement.down_payment,
        deposit_amount: this.agreement.deposit_amount,
        person: this.agreement.person,
        product_name: this.agreement.product_name,
        payment_type: this.watchAgreement.payment_type,
        payments_number: this.watchAgreement.payments_number,
        deposit_amount_date: this.agreement.deposit_amount_date,
        text_type: this.watchAgreement.text_type,
        text_grade_number: this.agreement.text_grade_number,
        text_payment_period_start: this.agreement.text_payment_period_start,
        text_payment_period_end: this.agreement.text_payment_period_end,
        service_period_start: this.agreement.service_period_start,
        service_period_end: this.agreement.service_period_end,
        administrative_expense: this.agreement.administrative_expense,
        first_month_deposit: this.agreement.first_month_deposit,
        first_month_deposit_method: this.watchAgreement.first_month_deposit_method,
        first_month_deposit_check: this.agreement.first_month_deposit_check,
        admission_fee: this.agreement.admission_fee,
        admission_fee_method: this.watchAgreement.admission_fee_method,
        admission_fee_check: this.agreement.admission_fee_check,
        deposit: this.watchAgreement.deposit,
        deposit_check: this.agreement.deposit_check,
        deposit_refund_date: this.agreement.deposit_refund_date,
        deposit_method: this.watchAgreement.deposit_method,
        approval_date: this.agreement.approval_date,
        approval_number: this.agreement.approval_number,
        delivery_date: this.agreement.delivery_date,
        contract_collection_date: this.agreement.contract_collection_date,
        factor_collection_date: this.agreement.factor_collection_date,
        grade: this.agreement.grade,
        point_s: this.agreement.point_s,
        point_c: this.agreement.point_c,
        point_k: this.agreement.point_k,
        point_s_bulk: this.agreement.point_s_bulk,
        point_c_bulk: this.agreement.point_c_bulk,
        point_k_bulk: this.agreement.point_k_bulk,
        point_total: this.agreement.point_total,
        note: this.agreement.note
      }
      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('AgreementsAdd', setjson)
    },

    get () {
      // alert('get')
      let getjson = localStorage.getItem('AgreementsAdd')
      let obj = JSON.parse(getjson)

      this.watchAgreement.contract_type = obj['contract_type']
      this.agreement.contract_date = obj['contract_date']
      this.agreement.change_date = obj['change_date']
      this.watchAgreement.cancel_type = obj['cancel_type']
      this.agreement.cancel_date = obj['cancel_date']
      this.agreement.f_name = obj['f_name']
      this.agreement.l_name = obj['l_name']
      this.agreement.f_name_kana = obj['f_name_kana']
      this.agreement.l_name_kana = obj['l_name_kana']
      this.agreement.tel = obj['tel']
      this.agreement.tel2 = obj['tel2']
      this.agreement.address = obj['address']
      this.agreement.address2 = obj['address2']
      this.agreement.birthday = obj['birthday']
      this.agreement.hourly_pay = obj['hourly_pay']
      this.agreement.amount = obj['amount']
      this.agreement.discount = obj['discount']
      this.agreement.split_commission = obj['split_commission']
      this.agreement.sales_commission = obj['sales_commission']
      this.agreement.sales_commission_head = obj['sales_commission_head']
      this.agreement.sales_commission_branch = obj['sales_commission_branch']
      this.agreement.pure_amount = obj['pure_amount']
      this.agreement.pure_amount_head = obj['pure_amount_head']
      this.agreement.pure_amount_branch = obj['pure_amount_branch']
      this.agreement.old_amount = obj['old_amount']
      this.agreement.agency_commission = obj['agency_commission']
      this.agreement.agency_commission_head = obj['agency_commission_head']
      this.agreement.agency_commission_branch = obj['agency_commission_branch']
      this.agreement.purchase_amount = obj['purchase_amount']
      this.agreement.purchase_amount_head = obj['purchase_amount_head']
      this.agreement.purchase_amount_branch = obj['purchase_amount_branch']
      this.agreement.only_total_amount = obj['only_total_amount']
      this.agreement.only_total_amount_head = obj['only_total_amount_head']
      this.agreement.only_total_amount_branch = obj['only_total_amount_branch']
      this.agreement.down_payment = obj['down_payment']
      this.agreement.deposit_amount = obj['deposit_amount']
      this.agreement.person = obj['person']
      this.agreement.product_name = obj['product_name']
      this.watchAgreement.payment_type = obj['payment_type']
      this.watchAgreement.payments_number = obj['payments_number']
      this.agreement.deposit_amount_date = obj['deposit_amount_date']
      this.watchAgreement.text_type = obj['text_type']
      this.agreement.text_grade_number = obj['text_grade_number']
      this.agreement.text_payment_period_start = obj['text_payment_period_start']
      this.agreement.text_payment_period_end = obj['text_payment_period_end']
      this.agreement.service_period_start = obj['service_period_start']
      this.agreement.service_period_end = obj['service_period_end']
      this.agreement.administrative_expense = obj['administrative_expense']
      this.agreement.first_month_deposit = obj['first_month_deposit']
      this.watchAgreement.first_month_deposit_method = obj['first_month_deposit_method']
      this.agreement.first_month_deposit_check = obj['first_month_deposit_check']
      this.agreement.admission_fee = obj['admission_fee']
      this.watchAgreement.admission_fee_method = obj['admission_fee_method']
      this.agreement.admission_fee_check = obj['admission_fee_check']
      this.watchAgreement.deposit = obj['deposit']
      this.agreement.deposit_check = obj['deposit_check']
      this.agreement.deposit_refund_date = obj['deposit_refund_date']
      this.watchAgreement.deposit_method = obj['deposit_method']
      this.agreement.approval_date = obj['approval_date']
      this.agreement.approval_number = obj['approval_number']
      this.agreement.delivery_date = obj['delivery_date']
      this.agreement.contract_collection_date = obj['contract_collection_date']
      this.agreement.factor_collection_date = obj['factor_collection_date']
      this.agreement.grade = obj['grade']
      this.agreement.point_s = obj['point_s']
      this.agreement.point_c = obj['point_c']
      this.agreement.point_k = obj['point_k']
      this.agreement.point_s_bulk = obj['point_s_bulk']
      this.agreement.point_c_bulk = obj['point_c_bulk']
      this.agreement.point_k_bulk = obj['point_k_bulk']
      this.agreement.point_total = obj['point_total']
      this.agreement.note = obj['note']
      // console.log(obj)
    },

    reset () {
      this.watchAgreement.contract_type = ''
      this.agreement.contract_date = ''
      this.agreement.change_date = ''
      this.watchAgreement.cancel_type = ''
      this.agreement.cancel_date = ''
      this.agreement.f_name = ''
      this.agreement.l_name = ''
      this.agreement.f_name_kana = ''
      this.agreement.l_name_kana = ''
      this.agreement.tel = ''
      this.agreement.tel2 = ''
      this.agreement.address = ''
      this.agreement.address2 = ''
      this.agreement.birthday = ''
      this.agreement.hourly_pay = ''
      this.agreement.amount = ''
      this.agreement.discount = ''
      this.agreement.split_commission = ''
      this.agreement.sales_commission = ''
      this.agreement.sales_commission_head = ''
      this.agreement.sales_commission_branch = ''
      this.agreement.pure_amount = ''
      this.agreement.pure_amount_head = ''
      this.agreement.pure_amount_branch = ''
      this.agreement.old_amount = ''
      this.agreement.agency_commission = ''
      this.agreement.agency_commission_head = ''
      this.agreement.agency_commission_branch = ''
      this.agreement.purchase_amount = ''
      this.agreement.purchase_amount_head = ''
      this.agreement.purchase_amount_branch = ''
      this.agreement.only_total_amount = ''
      this.agreement.only_total_amount_head = ''
      this.agreement.only_total_amount_branch = ''
      this.agreement.down_payment = ''
      this.agreement.deposit_amount = ''
      this.agreement.person = ''
      this.agreement.product_name = ''
      this.watchAgreement.payment_type = ''
      this.watchAgreement.payments_number = ''
      this.agreement.deposit_amount_date = ''
      this.watchAgreement.text_type = ''
      this.agreement.text_grade_number = ''
      this.agreement.text_payment_period_start = ''
      this.agreement.text_payment_period_end = ''
      this.agreement.service_period_start = ''
      this.agreement.service_period_end = ''
      this.agreement.administrative_expense = ''
      this.agreement.first_month_deposit = ''
      this.watchAgreement.first_month_deposit_method = ''
      this.agreement.first_month_deposit_check = ''
      this.agreement.admission_fee = ''
      this.watchAgreement.admission_fee_method = ''
      this.agreement.admission_fee_check = ''
      this.watchAgreement.deposit = ''
      this.agreement.deposit_check = ''
      this.agreement.deposit_refund_date = ''
      this.watchAgreement.deposit_method = ''
      this.agreement.approval_date = ''
      this.agreement.approval_number = ''
      this.agreement.delivery_date = ''
      this.agreement.contract_collection_date = ''
      this.agreement.factor_collection_date = ''
      this.agreement.grade = ''
      this.agreement.point_s = ''
      this.agreement.point_c = ''
      this.agreement.point_k = ''
      this.agreement.point_s_bulk = ''
      this.agreement.point_c_bulk = ''
      this.agreement.point_k_bulk = ''
      this.agreement.point_total = ''
      this.agreement.note = ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.get()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.save()
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
  overflow: scroll;
  height: calc(100vh - 360px);
}
.errors {
  color: red;
}
.active {
  background: #455A64;
  color: #fff;
  border-left: solid 1px #fff;
  border-right: 0;
  border-top: 0;
  border-bottom: solid 1px #fff;
}
.reset, .all {
  background: #78909C;
  color: #fff;
  border-left: solid 1px #fff;
  border-right: 0;
  border-top: 0;
  border-bottom: solid 1px #fff;
}
.add {
  margin-top: 10px;
}
.u-btn {
  margin-top: 1rem;
}
.btn {
  /* background: #cdeeff; */
  cursor: pointer;
  z-index: 1;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
  font-size: 12px;
}
.index-box {
  height: calc(100vh - 250px);
  overflow: scroll;
  margin-top: 10px;
}
.del {
  text-align: center;
  cursor: pointer;
  /* width: 80px; */
  &:hover {
    background: black;
    color: white;
  }
}
</style>
<style lang="scss">
.StudentAgreements {
  .multiselect {
    min-height: 35px;
    min-width: 150px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 35px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 35px;
  }
  .multiselect__select {
    height: 35px;
    width: 26px;
    top: 2px;
    padding: 0;
  }
  .vdp-datepicker {
    input {
      height: 37px;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// StudentAgreements.vue?30232ce2